var _defs, _rect, _circle, _circle2, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJustsolar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "solarBg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f59e0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d97706"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "panelGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1e293b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0f172a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cellGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#38bdf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0284c7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 6,
    stdDeviation: 8,
    floodOpacity: 0.25
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 56,
    fill: "url(#solarBg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 85,
    r: 38,
    fill: "#fef3c7",
    opacity: 0.95,
    filter: "url(#shadow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 85,
    r: 30,
    fill: "#fbbf24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 32 L128 42 M128 128 L128 138 M75 85 L85 85 M171 85 L181 85 M90 47 L97 54 M159 116 L166 123 M90 123 L97 116 M159 54 L166 47",
    stroke: "#fef3c7",
    strokeWidth: 5,
    strokeLinecap: "round",
    opacity: 0.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48, 120)",
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "20,10 140,10 156,92 4,92",
    fill: "url(#panelGrad)",
    stroke: "#475569",
    strokeWidth: 3,
    rx: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26,16 61,16 57,48 18,48",
    fill: "url(#cellGrad)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66,16 99,16 99,48 62,48",
    fill: "url(#cellGrad)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104,16 135,16 142,48 104,48",
    fill: "url(#cellGrad)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17,53 56,53 51,86 9,86",
    fill: "url(#cellGrad)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61,53 99,53 99,86 56,86",
    fill: "url(#cellGrad)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104,53 143,53 151,86 104,86",
    fill: "url(#cellGrad)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 50,
    x2: 148,
    y2: 50,
    stroke: "#fef08a",
    strokeWidth: 1.5,
    opacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustsolar);
export default __webpack_public_path__ + "static/media/justsolar.e2a8eb8ffeca4b6fb9e9ceddb33e987f.svg";
export { ForwardRef as ReactComponent };